import { render, staticRenderFns } from "./hallMarquee.vue?vue&type=template&id=1e638ab0&scoped=true&"
import script from "./hallMarquee.vue?vue&type=script&lang=js&"
export * from "./hallMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e638ab0",
  null
  
)

export default component.exports